import { render, staticRenderFns } from "./TrailerModal.vue?vue&type=template&id=4902ce44&scoped=true"
import script from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrailerModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrailerModal.vue?vue&type=style&index=0&id=4902ce44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4902ce44",
  null
  
)

export default component.exports